import React, { useState } from 'react'
import { t } from 'i18next'
import { Box, Collapse, IconButton, Link, Table, TableBody, TableCell, TableRow, Typography, Stack } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { getCurrencyText } from "../../../shared/utils/hubstripe.js";
import BillingInvoiceChip from './BillingInvoiceChip';
import dayjs from 'dayjs';

type BillingInvoicesItemsRowProps = {
    row: any
}

function BillingInvoicesItemsRow({ row }: BillingInvoicesItemsRowProps) {
    const [open, setOpen] = useState(false);

    const downloadInvoice = (filename: any, filepath: any) => {
        fetch('https://api.quote.equimetre.com/download?filename=' + filename + '&filepath=' + filepath, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    filename,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                if (link.parentNode) {
                    link.parentNode.removeChild(link);
                }
            });
    }

    let totalInvoiced = row.total
    let totalCredited = row.creditNotes.map((creditNote: any) => { return creditNote.total }).reduce(getSum, 0)
    let total = totalInvoiced - totalCredited

    function getSum(total: number, num: number) {
        return total + num;
    }

    return (
        <React.Fragment>
            <TableRow
                key={row.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell style={{ width: '50px' }}>
                    {row.creditNotes.length > 0 && (
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    )}
                </TableCell>
                <TableCell align="center">
                    {total == row.total && getCurrencyText(total / 100, row.currency)}
                    {total != row.total && (
                        <div>
                            <Typography variant="body2" sx={{ textDecoration: "line-through" }}>
                                {getCurrencyText(row.total / 100, row.currency)}
                            </Typography>
                            {getCurrencyText(total / 100, row.currency)}
                        </div>

                    )}
                </TableCell>
                <TableCell align="center">{row?.effective_at ? dayjs.unix(row.effective_at).format('MM/DD/YYYY') : ''}</TableCell>
                <TableCell align="center">

                    {row.status != 'paid' && row.amount_remaining > 0 ? (
                        <div>
                            <div>
                                <Link href={row.hosted_invoice_url}>{t("billing:payment_page")}</Link>
                            </div>
                        </div>
                    ) : <BillingInvoiceChip invoice={row} />}
                </TableCell>
                <TableCell align="center">{row.number}</TableCell>
                <TableCell align="center">
                    <Stack spacing={1}>
                        {row.cegidDocs.map((doc: any, index: number) => (
                            <Stack direction="row" spacing={2} key={index} alignItems="center" justifyContent="center">
                                {doc.filename}
                                <IconButton aria-label="delete">
                                    <DownloadIcon onClick={() => downloadInvoice(doc.filename, doc.filepath)} />
                                </IconButton>
                            </Stack>
                        )
                        )}
                    </Stack>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit style={{ padding: 0 }}>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="body1" gutterBottom component="div">
                                {t("billing:credit_notes_applied")} :
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableBody>
                                    {row.creditNotes.map((creditNote: any) => (
                                        <TableRow
                                            key={creditNote.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell style={{ width: '50px' }}>

                                            </TableCell>
                                            <TableCell align="center">
                                                {getCurrencyText(creditNote.total / 100, creditNote.currency)}
                                            </TableCell>
                                            <TableCell align="center">{(new Date(creditNote.effective_at * 1000)).toLocaleDateString()}</TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center">{creditNote.number}</TableCell>
                                            <TableCell align="center">
                                                <Stack spacing={1} >
                                                    {creditNote.cegidDocs.map((doc: any) => (
                                                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                                                            {doc.filename}
                                                            <IconButton aria-label="delete">
                                                                <DownloadIcon onClick={() => downloadInvoice(doc.filename, doc.filepath)} />
                                                            </IconButton>
                                                        </Stack>
                                                    )
                                                    )}
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment >
    );
}

export default BillingInvoicesItemsRow;